import { useState } from "react";

const initialStatebox = {
  ejercicio: new Date().getFullYear(),
  periodo: new Date().getMonth() + 1,
  filtrado: "",
  titulosucursal: "",
  titulodepartamento: "",
  arrayadr: [],
  arraysucursal: [],
  arraydepartamento: [],
  pv: { adr: [], sucursal: [], departamento: [] },
};
export const useBox = (initialState = initialStatebox) => {
  const [boxstate, setBoxState] = useState(initialState);

  const BoxChange = (name, value) => {
    setBoxState({
      ...boxstate,
      [name]: value,
    });
  };

  return [boxstate, BoxChange, setBoxState];
};

export const useBoxFiltros = (initialState = initialStatebox) => {
  const [boxstate, setBoxState] = useState(initialState);

  const BoxChange = (name, value) => {
    setBoxState({
      ...boxstate,
      [name]: value,
    });
  };

  return [boxstate, BoxChange];
};
